import { render, staticRenderFns } from "./MedicineSummaryGVS.vue?vue&type=template&id=604740bf"
import script from "./MedicineSummaryGVS.vue?vue&type=script&lang=js"
export * from "./MedicineSummaryGVS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports